<template>
  <DefaultLayout>
    <div class="flex flex-col items-center justify-around h-full mt-[4.5rem] px-3">
      <div class="flex flex-col items-center justify-center">
        <AgeSelector />
        <button
          type="button"
          class="mt-5 mb-4 max-w-[92%] rounded-xl border-2 border-jm_orange bg-jm_dark_green/90 px-5 py-3 text-center text-[13px] font-bold uppercase leading-tight text-jm_white shadow-lg shadow-black/20 underline decoration-jm_orange decoration-2 underline-offset-4"
          @click="globalStore.openTermsAndConditions('ageCheck')"
        >
          {{ $t("age_check.legal_conditions") }}
        </button>
      </div>

      <div class="relative flex flex-col justify-center items-center"></div>
    </div>
  </DefaultLayout>
</template>

<script lang="ts" setup>
import DefaultLayout from "../layouts/DefaultLayout.vue";
import AgeSelector from "@/components/AgeSelector.vue";
import { useGlobalStore } from "../stores/global";

const globalStore = useGlobalStore();
</script>

<style lang="scss" scoped>
@import "@/assets/sass/main.sass";
</style>
